import FileUpload from "@mui/icons-material/FileUpload";
import { Button, ButtonProps, Menu, SxProps } from "@mui/material";
import { ReactElement, cloneElement, useState } from "react";

import { ImporterProps } from "./index";

interface ImportDropdownProps {
  importers: { name: string; importer: ReactElement<ImporterProps> }[];
  color?: ButtonProps["color"];
  sx?: SxProps;
}

export function ImportDropdown({ importers, color, sx }: ImportDropdownProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button startIcon={<FileUpload />} onClick={handleClick} sx={sx} color={color}>
        Import
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        // Prevent menu from affecting body scroll, which triggers DataGrid's ResizeObserver
        disableScrollLock
      >
        {importers.map((importer, index) =>
          cloneElement(importer.importer, {
            key: index,
            mode: "dropdown" as const,
            label: importer.name,
          })
        )}
      </Menu>
    </>
  );
}
